module.exports = __webpack_public_path__ + "static/media/interface@x1.46fd9c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/interface@x1.png
// module id = 188
// module chunks = 0